import { render } from "./ImportSalesReturn.vue?vue&type=template&id=a8a5b51c"
import script from "./ImportSalesReturn.vue?vue&type=script&lang=js"
export * from "./ImportSalesReturn.vue?vue&type=script&lang=js"

import "./ImportSalesReturn.vue?vue&type=style&index=0&id=a8a5b51c&lang=css"
script.render = render

export default script